import React from 'react';
import { Box } from '@costar/theme-ui';

var SaveMsg = function SaveMsg(_ref) {
  var message = _ref.message;
  return /*#__PURE__*/React.createElement(Box, {
    color: "white",
    paddingY: "sm",
    bg: "primary",
    borderRadius: "2rem",
    textAlign: "center",
    fontFamily: "body",
    fontSize: "md",
    marginTop: "10%"
  }, message);
};

export { SaveMsg };
//# sourceMappingURL=save-message.esm.js.map
